import React, { useState } from "react";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import { faGithub } from '@fortawesome/free-brands-svg-icons'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons'
import './projectCard.css'

export function ProjectCard({ project }) {
  const [showLink, setShowLink] = useState(false);

  const showPreview = () => {
    setShowLink(!showLink);
    var arrow = document.getElementById("arrow");
    var box = document.getElementById("box");

    if (showLink) {
      arrow.className = " PreviewBox_Img PreviewBox_ImgUp";
      box.className = "PreviewBox PreviewBoxUp";
    } else {
      arrow.className = "PreviewBox_Img PreviewBox_ImgDown";
      box.className = "PreviewBox PreviewBoxDown";
    }
  };

  return (
    <div>
      <div className="DescriptionBox">
        <div className="BottomBox">
          <h3>Uitleg:</h3>
          {project.preview && (
            <div
              id="box"
              className="PreviewBox PreviewBoxUp"
              onClick={showPreview}
            >
              <div id="arrow" className="PreviewBox_Img PreviewBox_ImgUp">
                <FontAwesomeIcon icon={faChevronDown} />
              </div>

              {showLink && (
                <a
                  className="PreviewBox_Text"
                  rel="noopener noreferrer"
                  target="_blank"
                  href={project.preview}
                >
                  <div>Ga naar de site van {project.title} </div>
                </a>
              )}
            </div>
          )}
        </div>

        <div style={{ whiteSpace: "pre-wrap" }}>{project.description}</div>
      </div>

      <div className="BottomBox">
        <div>
          <h3>Framework:</h3>
          <div>{project.type}</div>
        </div>
        <div className="BottomBox_GithubBox">
          <a rel="noopener noreferrer" target="_blank" href={project.link}>
            <FontAwesomeIcon className="BottomBox_GithubBox_Image" icon={faGithub} />
          </a>
        </div>
      </div>
    </div>
  );
}
